export default {
  bannersList: [],
  manageBanner: null
}
